import { getInclusiveDayCount } from "utils/helpers";
import { TravelerKinds } from "utils/constants";

// A student's faculty number is optional, so only the filled-in ones are compared.
const DUPLICATE_CHECKS = [
  { kind: TravelerKinds.Employee, source: "employeeId", message: "Служителят е добавен повече от веднъж!" },
  { kind: TravelerKinds.Student, source: "facultyNumber", message: "Пътуващият е добавен повече от веднъж!" },
];

export const validateTravelers = travelers => {
  if (!travelers?.length) return "Моля, добавете поне един пътуващ!";

  for (const { kind, source, message } of DUPLICATE_CHECKS) {
    const ids = travelers.filter(t => t?.travelerKind === kind).map(t => t?.[source]).filter(Boolean);
    if (new Set(ids).size !== ids.length) return message;
  }
};

// react-admin's required() accepts `false` as a present value, so a checkbox needs its own rule.
export const validateChecked = message => value => (value ? undefined : message);

export const validateDailyAllowanceDaysAndNights = (
  dailyAllowanceDays, 
  nightsCount
) => () => {
  if (dailyAllowanceDays !== nightsCount + 1) {
    return "Броят на дните с пари трябва да е с 1 повече от броя нощувки !";
  }
}

export const validateBusinessTripDays = (
  startDate,
  endDate,
  dailyAllowanceDays,
  nightsCount
) => () => {

  const tripDaysTotal = getInclusiveDayCount(startDate, endDate);
  if (tripDaysTotal == null) return;

  if (dailyAllowanceDays > tripDaysTotal) {
    return "Броят дни с дневни пари надвишава времетраенето на командировката !"
  }

  if (nightsCount > tripDaysTotal - 1) {
    return "Броят нощувки надвишава времетраенето на командировката !"
  }
}

export const validateStart = (
  start,
  end,
  required = false,
  message = "Началната дата трябва да е по-малка от крайната",
  campare = null,
  campareMessage = null,
) => {
  if (!start && !required) return undefined;
  if (!start && required) {
    return "Полето е задължително";
  }
  if (start && campare && campare >= start) {
    return campareMessage;
  }
  if (start > end && required) {
    return message;
  }
};

export const validateEnd = (
  end,
  start,
  required = false,
  message = "Крайната дата трябва да е по-голяма от началната",
) => {
  if (!end && !required) return undefined;
  if (!end && required) {
    return "Полето е задължително";
  }
  if (end < start && required) {
    return message;
  }
};

export const validateDateInAMonth = (
  date,
) => {
  if (!date) return undefined;
  const currentDate = new Date();
  const selectedDate = new Date(date);
  const monthBefore = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());
  if (selectedDate < monthBefore) {
    return "Избраната дата трябва да е в рамките на 1 месец от датата на заявлението !";
  };
}